(function () {
  var pickerSelector = '[data-free-offer-picker]';
  var initializedAttribute = 'data-free-offer-initialized';

  function initAll(root) {
    (root || document).querySelectorAll(pickerSelector).forEach(initPicker);
  }

  function initPicker(picker) {
    if (picker.hasAttribute(initializedAttribute)) {
      return;
    }

    picker.setAttribute(initializedAttribute, 'true');

    var modal = picker.querySelector('[data-free-offer-modal]');
    var form = findProductForm(picker);
    var selectedGift = null;
    var lastFocusedElement = null;
    var isAdding = false;
    var isPassingMainAddToTheme = false;
    var lockedScrollY = 0;

    promoteModalToBody(modal);

    picker.querySelectorAll('[data-free-offer-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        openModal();
      });
    });

    queryOfferElements(picker, modal, '[data-free-offer-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        closeModal();
      });
    });

    queryOfferElements(picker, modal, '[data-free-offer-variant-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        updateCardPrice(select);
      });

      updateCardPrice(select);
    });

    queryOfferElements(picker, modal, '[data-free-offer-sort-dropdown]').forEach(initSortDropdown);
    initOfferPagination(modal);

    queryOfferElements(picker, modal, '[data-free-offer-select]').forEach(function (button) {
      button.addEventListener('click', function () {
        var card = button.closest('[data-free-offer-card]');
        var select = card && card.querySelector('[data-free-offer-variant-select]');
        var option = select && select.options[select.selectedIndex];

        if (!option) {
          return;
        }

        selectedGift = optionToGift(option);
        hideCartError();
        setMainProductGiftProperty(form, selectedGift.variantId);
        updateSummary(picker, selectedGift);
        updateDynamicCheckout(form, true);
        closeModal();
      });
    });

    var clearButton = picker.querySelector('[data-free-offer-clear]');

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        selectedGift = null;
        removeMainProductGiftProperty(form);
        updateSummary(picker, null);
        updateDynamicCheckout(form, false);
      });
    }

    if (modal) {
      modal.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeModal();
        }
      });

      modal.addEventListener('click', function (event) {
        if (event.target && event.target.closest && event.target.closest('[data-free-offer-sort-dropdown]')) {
          return;
        }

        closeSortDropdowns(modal);
      });
    }

    if (form) {
      form.addEventListener(
        'submit',
        handleProductAdd,
        true
      );

      form.querySelectorAll('button[type="submit"], input[type="submit"], [name="add"], [data-action="add-to-cart"]').forEach(function (button) {
        button.addEventListener('click', handleProductAdd, true);
      });
    }

    function handleProductAdd(event) {
      if (isPassingMainAddToTheme) {
        return;
      }

      if (!selectedGift) {
        return;
      }

      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }

      if (isAdding) {
        return;
      }

      hideCartError();
      isAdding = true;

      addGiftThenRunNormalMainAdd(form, selectedGift, event).then(function () {
        isPassingMainAddToTheme = true;
        submitMainProductThroughTheme(form, getSubmitterFromEvent(event, form));

        window.setTimeout(function () {
          isPassingMainAddToTheme = false;
          isAdding = false;
        }, 1200);
      }).catch(function (error) {
        showCartError(getCartErrorMessage(error));
        setFormLoading(form, false);
        isAdding = false;
      });
    }

    function openModal() {
      if (!modal) {
        return;
      }

      lastFocusedElement = document.activeElement;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      lockPageScroll();
      updateOfferPagination(modal, getCurrentOfferPage(modal));

      var focusTarget = modal.querySelector('[data-free-offer-close], button, select, a[href]');

      if (focusTarget) {
        focusTarget.focus();
      }
    }

    function closeModal() {
      if (!modal) {
        return;
      }

      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      unlockPageScroll();

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }

    function lockPageScroll() {
      lockedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.documentElement.classList.add('free-offer-picker-is-open');
      document.body.classList.add('free-offer-picker-is-open');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + lockedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlockPageScroll() {
      document.documentElement.classList.remove('free-offer-picker-is-open');
      document.body.classList.remove('free-offer-picker-is-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, lockedScrollY);
    }
  }

  function findProductForm(picker) {
    var formId = picker.getAttribute('data-product-form-id');

    if (formId) {
      return document.getElementById(formId);
    }

    return picker.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  }

  function getSubmitterFromEvent(event, form) {
    if (!event) {
      return findMainAddButton(form);
    }

    if (event.submitter) {
      return event.submitter;
    }

    if (event.currentTarget && event.currentTarget !== form && isSubmitControl(event.currentTarget)) {
      return event.currentTarget;
    }

    if (event.target && event.target !== form && event.target.closest) {
      var submitter = event.target.closest('button[type="submit"], input[type="submit"], [name="add"], [data-action="add-to-cart"]');

      if (submitter) {
        return submitter;
      }
    }

    return findMainAddButton(form);
  }

  function isSubmitControl(element) {
    return element.matches && element.matches('button[type="submit"], input[type="submit"], [name="add"], [data-action="add-to-cart"]');
  }

  function findMainAddButton(form) {
    if (!form) {
      return null;
    }

    return form.querySelector('button[type="submit"], input[type="submit"], [name="add"], [data-action="add-to-cart"]');
  }

  function submitMainProductThroughTheme(form, submitter) {
    if (submitter && typeof submitter.click === 'function') {
      submitter.click();
      return;
    }

    if (form && typeof form.requestSubmit === 'function') {
      form.requestSubmit();
      return;
    }

    if (form) {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  function setMainProductGiftProperty(form, giftVariantId) {
    if (!form || !giftVariantId) {
      return;
    }

    var input = form.querySelector('[data-free-offer-main-property]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_selected_free_offer_variant]';
      input.setAttribute('data-free-offer-main-property', '');
      form.appendChild(input);
    }

    input.value = String(giftVariantId);
  }

  function removeMainProductGiftProperty(form) {
    if (!form) {
      return;
    }

    form.querySelectorAll('[data-free-offer-main-property]').forEach(function (input) {
      input.parentElement.removeChild(input);
    });
  }

  function promoteModalToBody(modal) {
    if (!modal || modal.parentElement === document.body) {
      return;
    }

    if (modal.id) {
      document.querySelectorAll('[id="' + modal.id + '"][data-free-offer-modal]').forEach(function (existingModal) {
        if (existingModal !== modal) {
          existingModal.parentElement.removeChild(existingModal);
        }
      });
    }

    document.body.appendChild(modal);
  }

  function queryOfferElements(picker, modal, selector) {
    var elements = [];

    if (picker) {
      elements = elements.concat(Array.prototype.slice.call(picker.querySelectorAll(selector)));
    }

    if (modal) {
      elements = elements.concat(Array.prototype.slice.call(modal.querySelectorAll(selector)));
    }

    return elements;
  }

  function optionToGift(option) {
    return {
      variantId: option.value,
      productTitle: option.getAttribute('data-product-title') || '',
      variantTitle: option.getAttribute('data-variant-title') || '',
      price: option.getAttribute('data-price') || '',
      image: option.getAttribute('data-image') || ''
    };
  }

  function updateSummary(picker, gift) {
    var imageTarget = picker.querySelector('[data-free-offer-summary-image]');
    var titleTarget = picker.querySelector('[data-free-offer-summary-title]');
    var variantTarget = picker.querySelector('[data-free-offer-summary-variant]');
    var priceTarget = picker.querySelector('[data-free-offer-summary-price]');
    var priceWrapTarget = picker.querySelector('[data-free-offer-summary-price-wrap]');
    var clearButton = picker.querySelector('[data-free-offer-clear]');

    if (!gift) {
      picker.classList.remove('free-offer-picker--selected');

      if (imageTarget) {
        imageTarget.innerHTML = getDefaultOfferIconHtml();
      }

      if (titleTarget) {
        titleTarget.textContent = 'Choose Your Gift Thangka';
      }

      if (variantTarget) {
        variantTarget.textContent = 'Tap to browse the collection';
      }

      if (priceTarget) {
        priceTarget.textContent = '';
      }

      if (priceWrapTarget) {
        priceWrapTarget.hidden = true;
      }

      if (clearButton) {
        clearButton.hidden = true;
      }

      return;
    }

    picker.classList.add('free-offer-picker--selected');

    if (imageTarget) {
      if (gift.image) {
        imageTarget.innerHTML = '<img src="' + escapeAttribute(gift.image) + '" alt="" width="96" height="120" loading="lazy">';
      } else {
        imageTarget.innerHTML = getDefaultOfferIconHtml();
      }
    }

    if (titleTarget) {
      titleTarget.textContent = gift.productTitle || 'Selected offer product';
    }

    if (variantTarget) {
      variantTarget.textContent = normalizeVariantTitle(gift.variantTitle);
    }

    if (priceTarget) {
      priceTarget.textContent = gift.price;
    }

    if (priceWrapTarget) {
      priceWrapTarget.hidden = !gift.price;
    }

    if (clearButton) {
      clearButton.hidden = false;
    }
  }

  function updateCardPrice(select) {
    var card = select.closest('[data-free-offer-card]');
    var priceTarget = card && card.querySelector('[data-free-offer-card-price]');
    var variantNameTarget = card && card.querySelector('[data-free-offer-card-variant-name]');
    var option = select.options[select.selectedIndex];

    if (priceTarget && option) {
      priceTarget.textContent = option.getAttribute('data-price') || '';
    }

    if (variantNameTarget && option) {
      variantNameTarget.textContent = normalizeVariantTitle(option.getAttribute('data-variant-title') || option.textContent || '');
    }
  }

  function initSortDropdown(dropdown) {
    var trigger = dropdown.querySelector('[data-free-offer-sort-toggle]');
    var menu = dropdown.querySelector('[data-free-offer-sort-menu]');
    var options = Array.prototype.slice.call(dropdown.querySelectorAll('[data-free-offer-sort-option]'));
    var selectedOption = options.filter(function (option) {
      return option.getAttribute('aria-selected') === 'true';
    })[0] || options[0];

    if (!trigger || !menu || !options.length) {
      return;
    }

    setSortDropdownOption(dropdown, selectedOption, true);
    sortOfferCards(dropdown, selectedOption.value);

    trigger.addEventListener('click', function () {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        closeSortDropdown(dropdown);
      } else {
        openSortDropdown(dropdown);
      }
    });

    dropdown.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeSortDropdown(dropdown);
        trigger.focus();
      }
    });

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        setSortDropdownOption(dropdown, option, true);
        sortOfferCards(dropdown, option.value);
        closeSortDropdown(dropdown);
        trigger.focus();
      });
    });
  }

  function openSortDropdown(dropdown) {
    var modal = dropdown.closest('[data-free-offer-modal]');
    var trigger = dropdown.querySelector('[data-free-offer-sort-toggle]');
    var menu = dropdown.querySelector('[data-free-offer-sort-menu]');

    closeSortDropdowns(modal, dropdown);

    if (trigger && menu) {
      trigger.setAttribute('aria-expanded', 'true');
      dropdown.classList.add('is-open');
      menu.hidden = false;
    }
  }

  function closeSortDropdown(dropdown) {
    var trigger = dropdown.querySelector('[data-free-offer-sort-toggle]');
    var menu = dropdown.querySelector('[data-free-offer-sort-menu]');

    if (trigger && menu) {
      trigger.setAttribute('aria-expanded', 'false');
      dropdown.classList.remove('is-open');
      menu.hidden = true;
    }
  }

  function closeSortDropdowns(root, exceptDropdown) {
    if (!root || !root.querySelectorAll) {
      return;
    }

    root.querySelectorAll('[data-free-offer-sort-dropdown]').forEach(function (dropdown) {
      if (dropdown !== exceptDropdown) {
        closeSortDropdown(dropdown);
      }
    });
  }

  function setSortDropdownOption(dropdown, selectedOption, shouldUpdateLabel) {
    var currentLabel = dropdown.querySelector('[data-free-offer-sort-current]');

    dropdown.querySelectorAll('[data-free-offer-sort-option]').forEach(function (option) {
      var isSelected = option === selectedOption;

      option.classList.toggle('is-selected', isSelected);
      option.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });

    if (shouldUpdateLabel && currentLabel) {
      currentLabel.textContent = selectedOption.textContent.trim();
    }
  }

  function sortOfferCards(context, selectedSortValue) {
    var modal = context.closest('[data-free-offer-modal]');
    var list = modal && modal.querySelector('.free-offer-picker__list');

    if (!list) {
      return;
    }

    var sortValue = selectedSortValue || context.value || 'title-ascending';
    var cards = Array.prototype.slice.call(list.querySelectorAll('[data-free-offer-card]'));

    cards.sort(function (firstCard, secondCard) {
      var firstTitle = (firstCard.getAttribute('data-free-offer-card-sort-title') || '').trim();
      var secondTitle = (secondCard.getAttribute('data-free-offer-card-sort-title') || '').trim();
      var firstPrice = parseInt(firstCard.getAttribute('data-free-offer-card-sort-price') || '0', 10);
      var secondPrice = parseInt(secondCard.getAttribute('data-free-offer-card-sort-price') || '0', 10);
      var firstIndex = parseInt(firstCard.getAttribute('data-free-offer-card-sort-index') || '0', 10);
      var secondIndex = parseInt(secondCard.getAttribute('data-free-offer-card-sort-index') || '0', 10);

      if (sortValue === 'manual') {
        return firstIndex - secondIndex;
      }

      if (sortValue === 'price-ascending') {
        return firstPrice - secondPrice || firstTitle.localeCompare(secondTitle);
      }

      if (sortValue === 'price-descending') {
        return secondPrice - firstPrice || firstTitle.localeCompare(secondTitle);
      }

      if (sortValue === 'title-descending') {
        return secondTitle.localeCompare(firstTitle);
      }

      return firstTitle.localeCompare(secondTitle);
    });

    cards.forEach(function (card) {
      list.appendChild(card);
    });

    updateOfferPagination(modal, 1);
  }

  function initOfferPagination(modal) {
    var footer = modal && modal.querySelector('[data-free-offer-pagination]');
    var controls = footer && footer.querySelector('[data-free-offer-pagination-pages]');

    if (!modal || !footer || !controls) {
      return;
    }

    controls.addEventListener('click', function (event) {
      var button = event.target && event.target.closest && event.target.closest('[data-free-offer-page]');

      if (!button) {
        return;
      }

      event.preventDefault();
      updateOfferPagination(modal, getOfferPageFromButton(modal, button), true);
    });

    window.addEventListener('resize', debounce(function () {
      updateOfferPagination(modal, getCurrentOfferPage(modal));
    }, 150));

    updateOfferPagination(modal, 1);
  }

  function updateOfferPagination(modal, requestedPage, shouldScroll) {
    var body = modal && modal.querySelector('[data-free-offer-body]');
    var list = modal && modal.querySelector('.free-offer-picker__list');
    var footer = modal && modal.querySelector('[data-free-offer-pagination]');
    var status = modal && modal.querySelector('[data-free-offer-pagination-status]');
    var controls = footer && footer.querySelector('[data-free-offer-pagination-pages]');

    if (!modal || !list) {
      return;
    }

    var cards = Array.prototype.slice.call(list.querySelectorAll('[data-free-offer-card]'));
    var totalProducts = cards.length;

    if (!totalProducts) {
      if (footer) {
        footer.hidden = true;
      }

      if (status) {
        status.textContent = '';
      }

      return;
    }

    var itemsPerPage = getOfferItemsPerPage(list);
    var totalPages = Math.max(1, Math.ceil(totalProducts / itemsPerPage));
    var currentPage = Math.min(Math.max(parseInt(requestedPage, 10) || 1, 1), totalPages);
    var startIndex = (currentPage - 1) * itemsPerPage;
    var endIndex = Math.min(startIndex + itemsPerPage, totalProducts);

    cards.forEach(function (card, index) {
      var isVisible = index >= startIndex && index < endIndex;

      card.hidden = !isVisible;
      card.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    });

    modal.setAttribute('data-free-offer-current-page', String(currentPage));

    if (status) {
      status.textContent = 'Showing ' + (startIndex + 1) + ' - ' + endIndex + ' of ' + totalProducts + ' products';
    }

    if (controls) {
      controls.innerHTML = renderOfferPaginationControls(currentPage, totalPages);
      controls.hidden = totalPages <= 1;
    }

    if (footer) {
      footer.hidden = totalPages <= 1;
    }

    if (shouldScroll) {
      (body || list).scrollTop = 0;
    }
  }

  function getOfferItemsPerPage(list) {
    return Math.max(1, getOfferGridColumnCount(list) * 5);
  }

  function getOfferGridColumnCount(list) {
    if (!list || !window.getComputedStyle) {
      return 1;
    }

    var gridTemplateColumns = window.getComputedStyle(list).gridTemplateColumns || '';
    var columns = gridTemplateColumns.split(' ').filter(function (column) {
      return column && column !== 'none';
    });

    return Math.max(columns.length || 1, 1);
  }

  function getCurrentOfferPage(modal) {
    return parseInt(modal && modal.getAttribute('data-free-offer-current-page'), 10) || 1;
  }

  function getOfferPageFromButton(modal, button) {
    var pageValue = button.getAttribute('data-free-offer-page');

    if (pageValue === 'previous') {
      return getCurrentOfferPage(modal) - 1;
    }

    if (pageValue === 'next') {
      return getCurrentOfferPage(modal) + 1;
    }

    return parseInt(pageValue, 10) || 1;
  }

  function renderOfferPaginationControls(currentPage, totalPages) {
    if (totalPages <= 1) {
      return '';
    }

    var html = [];
    var tokens = buildOfferPaginationTokens(currentPage, totalPages);

    if (currentPage > 1) {
      html.push('<button type="button" class="free-offer-picker__pagination-link free-offer-picker__pagination-link--edge free-offer-picker__pagination-link--previous" data-free-offer-page="previous"><span aria-hidden="true">&lt;</span> Prev</button>');
    }

    tokens.forEach(function (token) {
      if (token === 'ellipsis') {
        html.push('<span class="free-offer-picker__pagination-ellipsis" aria-hidden="true">...</span>');
        return;
      }

      html.push('<button type="button" class="free-offer-picker__pagination-link' + (token === currentPage ? ' is-current' : '') + '" data-free-offer-page="' + token + '"' + (token === currentPage ? ' aria-current="page"' : '') + '>' + token + '</button>');
    });

    if (currentPage < totalPages) {
      html.push('<button type="button" class="free-offer-picker__pagination-link free-offer-picker__pagination-link--edge free-offer-picker__pagination-link--next" data-free-offer-page="next">Next <span aria-hidden="true">&gt;</span></button>');
    }

    return html.join('');
  }

  function buildOfferPaginationTokens(currentPage, totalPages) {
    var pageMap = {};
    var pages = [];
    var tokens = [];
    var page;

    function addPage(candidatePage) {
      if (candidatePage >= 1 && candidatePage <= totalPages) {
        pageMap[candidatePage] = true;
      }
    }

    addPage(1);
    addPage(totalPages);
    addPage(currentPage - 1);
    addPage(currentPage);
    addPage(currentPage + 1);

    if (currentPage <= 2) {
      addPage(2);
      addPage(3);
    }

    if (currentPage >= totalPages - 1) {
      addPage(totalPages - 2);
      addPage(totalPages - 1);
    }

    Object.keys(pageMap).forEach(function (pageNumber) {
      pages.push(parseInt(pageNumber, 10));
    });

    pages.sort(function (firstPage, secondPage) {
      return firstPage - secondPage;
    });

    pages.forEach(function (candidatePage, index) {
      if (index && candidatePage - page > 1) {
        tokens.push('ellipsis');
      }

      tokens.push(candidatePage);
      page = candidatePage;
    });

    return tokens;
  }

  function debounce(callback, wait) {
    var timeoutId;

    return function () {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(callback, wait);
    };
  }

  function normalizeVariantTitle(title) {
    if (!title || title === 'Default Title') {
      return 'Selected product';
    }

    return title;
  }

  function getDefaultOfferIconHtml() {
    return '<svg class="free-offer-picker__offer-icon" viewBox="0 0 32 32" aria-hidden="true" focusable="false"><path d="M4 13h24v15H4V13Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M3 9h26v6H3V9Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M16 9v19" fill="none" stroke="currentColor" stroke-width="2"/><path d="M16 9c-3.4 0-6-1.2-6-3.4C10 4 11.2 3 12.8 3 15.2 3 16 6 16 9Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M16 9c3.4 0 6-1.2 6-3.4C22 4 20.8 3 19.2 3 16.8 3 16 6 16 9Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>';
  }

  function updateDynamicCheckout(form, shouldHide) {
    if (!form) {
      return;
    }

    form.querySelectorAll('.shopify-payment-button').forEach(function (element) {
      element.classList.toggle('free-offer-picker__payment-hidden', shouldHide);
    });
  }

  function addGiftThenRunNormalMainAdd(form, gift) {
    var formData = new FormData(form);
    var mainVariantId = formData.get('id');

    if (!mainVariantId || !gift.variantId) {
      return Promise.reject('Please select both products before adding to cart.');
    }

    var giftItem = {
      id: Number(gift.variantId),
      quantity: 1,
      properties: {
        _free_offer: 'true',
        _free_offer_for_variant: String(mainVariantId)
      }
    };

    setMainProductGiftProperty(form, gift.variantId);
    setFormLoading(form, true);

    return fetch(getShopifyRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [giftItem]
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (error) {
            throw error;
          });
        }

        return response.json();
      })
      .finally(function () {
        setFormLoading(form, false);
      });
  }

  function getCartErrorMessage(error) {
    if (!error) {
      return 'Could not add both products to cart. Please try again.';
    }

    if (typeof error === 'string') {
      return error;
    }

    return error.description || error.message || 'Could not add both products to cart. Please try again.';
  }

  function showCartError(message) {
    var existingError = document.querySelector('[data-buy-one-get-one-error]');

    if (existingError) {
      existingError.textContent = message;
      existingError.hidden = false;
      return;
    }

    window.alert(message);
  }

  function hideCartError() {
    var existingError = document.querySelector('[data-buy-one-get-one-error]');

    if (existingError) {
      existingError.textContent = '';
      existingError.hidden = true;
    }
  }

  function collectLineProperties(formData) {
    var properties = {};

    formData.forEach(function (value, key) {
      if (!key || key.indexOf('properties[') !== 0 || value === '') {
        return;
      }

      var propertyName = key.replace(/^properties\[/, '').replace(/\]$/, '');

      if (!propertyName) {
        return;
      }

      if (properties[propertyName]) {
        properties[propertyName] = properties[propertyName] + ', ' + value;
      } else {
        properties[propertyName] = value;
      }
    });

    return properties;
  }

  function setFormLoading(form, isLoading) {
    form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(function (button) {
      button.disabled = isLoading;
      button.classList.toggle('is-loading', isLoading);
    });
  }

  function notifyCartChanged(cartAddResponse) {
    var eventDetail = {
      cartAddResponse: cartAddResponse
    };

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: eventDetail }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: eventDetail }));
    document.dispatchEvent(new CustomEvent('free-offer:added', { bubbles: true, detail: eventDetail }));
  }

  function openCartAfterAdd() {
    triggerMiniCartControls();
    notifyMiniCartOpen();
    openMiniCartInner();

    [50, 150, 350, 700].forEach(function (delay) {
      window.setTimeout(openMiniCartInner, delay);
    });
  }

  function notifyMiniCartOpen() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent('mini-cart:open', { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true, detail: { id: 'mini-cart' } }));
  }

  function triggerMiniCartControls() {
    document.querySelectorAll(
      '[data-action="open-drawer"][aria-controls*="cart"], [data-action="open-drawer"][data-drawer-id*="cart"], [data-action="toggle-mini-cart"], [aria-controls*="mini-cart"], [href$="/cart"][aria-controls]'
    ).forEach(function (trigger) {
      trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    });
  }

  function openMiniCartInner() {
    var miniCartInners = document.querySelectorAll('.mini-cart__inner');

    if (!miniCartInners.length) {
      return;
    }

    miniCartInners.forEach(function (miniCartInner) {
      var miniCart = miniCartInner.closest('#mini-cart, .mini-cart, mini-cart, .drawer, [data-drawer], [aria-hidden]');
      var fallbackParent = miniCartInner.parentElement;

      openMiniCartElement(miniCartInner);

      if (miniCart) {
        openMiniCartElement(miniCart);
      }

      if (fallbackParent && fallbackParent !== miniCart) {
        openMiniCartElement(fallbackParent);
      }
    });

    document.documentElement.classList.add('mini-cart-is-open');
    document.documentElement.classList.add('drawer-is-open');
    document.body.classList.add('mini-cart-is-open');
    document.body.classList.add('drawer-is-open');
    document.body.classList.add('no-scroll');
  }

  function openMiniCartElement(element) {
    element.removeAttribute('hidden');
    element.setAttribute('aria-hidden', 'false');
    element.classList.add('is-open', 'is-visible', 'is-active', 'drawer--open');

    if (element.tagName === 'DETAILS') {
      element.open = true;
    }
  }

  function getShopifyRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function escapeAttribute(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  if (document.readyState !== 'loading') {
    initAll(document);
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) {
          return;
        }

        if (node.matches && node.matches(pickerSelector)) {
          initPicker(node);
        } else if (node.querySelectorAll) {
          initAll(node);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
